import React from 'react'
import SignupForm from '../Components/SignupForm/SignupForm'
import login from '../assets/login.PNG'
import { Col, Container, Row } from 'react-bootstrap'

function Signup() {
  return (
    <div className='h-100'>
<Container>
<Row>
  <Col md={6} className='img_container_grid'>
  <div>
    <img src={login}alt=''/>
  </div>
  </Col>
  <Col md={6}>       
   <SignupForm />
</Col>
</Row>
</Container>
    </div>
  )
}

export default Signup